var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForwardBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0116,
    rx: 4,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#C3CBDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79006 6.2958C8.88302 6.20207 8.99363 6.12768 9.11548 6.07691C9.23734 6.02614 9.36805 6 9.50006 6C9.63207 6 9.76278 6.02614 9.88464 6.07691C10.0065 6.12768 10.1171 6.20207 10.2101 6.2958L15.2101 11.2958C15.3038 11.3888 15.3782 11.4994 15.429 11.6212C15.4797 11.7431 15.5059 11.8738 15.5059 12.0058C15.5059 12.1378 15.4797 12.2685 15.429 12.3904C15.3782 12.5122 15.3038 12.6228 15.2101 12.7158L10.2101 17.7158C10.1171 17.8095 10.0065 17.8839 9.88464 17.9347C9.76278 17.9855 9.63207 18.0116 9.50006 18.0116C9.36805 18.0116 9.23734 17.9855 9.11548 17.9347C8.99363 17.8839 8.88302 17.8095 8.79006 17.7158C8.69633 17.6228 8.62194 17.5122 8.57117 17.3904C8.5204 17.2685 8.49426 17.1378 8.49426 17.0058C8.49426 16.8738 8.5204 16.7431 8.57117 16.6212C8.62194 16.4994 8.69633 16.3888 8.79006 16.2958L13.0901 12.0058L8.79006 7.7158C8.69633 7.62284 8.62194 7.51223 8.57117 7.39038C8.5204 7.26852 8.49426 7.13781 8.49426 7.0058C8.49426 6.87379 8.5204 6.74308 8.57117 6.62122C8.62194 6.49936 8.69633 6.38876 8.79006 6.2958Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardBoxIcon);
export default __webpack_public_path__ + "static/media/arrow-forward-box-icon.68d44bc24b42868943af835698b2a84a.svg";
export { ForwardRef as ReactComponent };